import { localisedValue, flattenHierarchy } from "utils"

const staffListTransformer = (
  response,
  flatListTransformation = false,
  requireSelfSellerData = false,
  getStaffValueObjectMapping = false
) => {
  const userSellerInfo = []
  const staffValueObjectMapping = {}

  const hierarchicalStaffTransformer = staffArray => {
    return staffArray.map(item => {
      const { children, ...remainingItems } = item
      const userInfo = {
        title: localisedValue({ object: remainingItems, key: "name" }),
        value: remainingItems?.userId?.toString(),
        key: remainingItems?.userId?.toString(),
        regionId: remainingItems?.regionId,
        selfSeller: remainingItems?.selfSeller,
        designation: localisedValue({object: remainingItems , key: "designationTitle"}),
        designationShort: localisedValue({object: remainingItems , key: "designationShort"})
      }
      staffValueObjectMapping[remainingItems?.userId?.toString()] = userInfo

      remainingItems?.selfSeller &&
        userSellerInfo.push({ userId: remainingItems?.userId.toString(), selfSeller: remainingItems?.selfSeller })
      if (children?.length) {
        userInfo.children = hierarchicalStaffTransformer(children)
      }

      return userInfo
    })
  }

  const data = !!response ? [response] : []
  const transformedArray = hierarchicalStaffTransformer(data)

  if (flatListTransformation) {
    const transformedData = flattenHierarchy(transformedArray[0])
    return requireSelfSellerData ? { transformedData, userSellerInfo } : transformedData
  } else if (requireSelfSellerData) {
    return { transformedData: transformedArray, userSellerInfo }
  } else if (getStaffValueObjectMapping) {
    return { transformedData: transformedArray, staffValueObjectMapping }
  } else {
    return transformedArray
  }
}

export default staffListTransformer
